import type { TutorBillingExportType } from '@brighterly/lib-core-types/tutor/enums'
import type { ApiResponse } from '@shared/api'
import type { RouteLocationNormalizedGeneric } from 'vue-router'

import { useAdminNow } from '@entities/viewer'
import { getAxiosErrorMessage } from '@shared/api'
import { pick } from '@shared/lib/collections'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { getTutorBillingFilterParams, queryToFilters } from '../lib/tutor-billing-query'
import { useTutorBillingStore } from '../model/store'

interface TutorBillingExportOptions {
  route?: RouteLocationNormalizedGeneric
}

export const useTutorBillingExport = async (
  type: TutorBillingExportType,
  options?: TutorBillingExportOptions,
): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const route = options?.route || useRoute()
  const store = useTutorBillingStore()

  const url = useAdminRoutes('admin.tutors.billing.export')
  const selectedIds = store.getSelectedIds

  store.setSaving(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    const { data } = await $axios.post<ApiResponse>(url, pick({
      type,
      ...getTutorBillingFilterParams(queryToFilters(route.query), useAdminNow()),
      ids: selectedIds.length ? selectedIds : undefined,
    }))

    if (!data.success) {
      toast.error(data.message)
      return false
    }

    toast.success(data.message)

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    store.setSaving(false)
  }
}
